(function () {
  // Prevent duplicate listeners when the Header is rendered more than once.
  if (window.__wbHeaderShopProductTrackingBound) return;
  window.__wbHeaderShopProductTrackingBound = true;

  // Event delegation also covers Drawer and Theme Editor DOM re-renders.
  document.addEventListener('click', function (clickEvent) {
    const clickedElement = clickEvent.target;
    if (!(clickedElement instanceof Element)) return;

    const productCardLink = clickedElement.closest('[data-header-shop-product]');
    if (!productCardLink) return;

    try {
      // Stable Shopify IDs and product name are required for the ecommerce item.
      const variantId = productCardLink.dataset.navItemId;
      const productId = productCardLink.dataset.navProductId;
      const productName = productCardLink.dataset.navItemName;
      if (!variantId || !productId || !productName) return;

      // The shared Drawer markup is classified by its active viewport.
      let navigationSurface = productCardLink.dataset.navSurface;
      if (navigationSurface === 'drawer') {
        navigationSurface = window.matchMedia('(max-width: 749px)').matches
          ? 'mobile_drawer'
          : 'tablet_drawer';
      }

      window.dataLayer = window.dataLayer || [];

      // Clear stale ecommerce data before GTM maps this event to GA4 select_item.
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'header_product_select',
        nav_entry_id: productCardLink.dataset.navEntryId,
        nav_surface: navigationSurface,
        nav_menu_id: productCardLink.dataset.navMenuId,
        destination_type: 'product',
        page_type: productCardLink.dataset.pageType,
        ecommerce: {
          items: [
            {
              item_id: variantId,
              item_product_id: productId,
              item_name: productName,
              item_variant: productCardLink.dataset.navItemVariant || '',
              item_list_id: 'header_shop_products',
              item_list_name: 'Header Shop Products',
              index: Number(productCardLink.dataset.navIndex)
            }
          ]
        }
      });
    } catch (trackingError) {
      // Fail open: analytics errors must not interrupt product navigation.
    }
  });
})();
